<template>
  <div :class="'message ' + (isOwnMessage ? 'self ' : 'other ') + (isAdminMessage ? 'admin ' : '')">
    <span v-if="groupIndex==0 && !isOwnMessage" :class="'sender'" @click.stop="onUserNameClicked()">
      <v-icon v-if="isAdminMessage" color="accent">mdi-hammer-wrench</v-icon>{{message.username}}
      <br />
    </span>
    <div class="content">{{message.message}}
      <span class="time">{{timestr}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "ChatMessage",
  components: {},
  props: {
    message: {
      type: Object,
      required: true,
    },
    groupIndex: {
      type: Number,
      default: 0
    },
    isAdminMessage: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      date: new Date()
    };
  },
  computed: {
    timestr: function() {
      return this.$datefns.formatTimeRelative(this.date)
    },
    isOwnMessage: function() {
      return this.message.userUID == this.$store.state.profile.uid
    }
  },
  watch: {},
  mounted() {
    this.date = new Date(this.message.timestamp * 1000);
  },
  beforeDestroy() {},
  methods: {
    onUserNameClicked() {
      this.$emit("userNameClicked", { message: this.message });
    }
  },
};
</script>

<style scoped>
.message {
  max-width: 80vw;
  min-width: 15vw;
  width: fit-content;
  margin: 2px 2px 2px 5px;
  border-radius: 7px;
  padding: 5px 7px;
}
.message .content {
  text-align: left;
}
.message .sender {
  /* font-weight: bold; */
  color: black;
}
.message.self .content {
  color: white;
}
.self {
  background-color: var(--v-secondary-base);
  margin-right: 5px;
  margin-left: auto;
}
.other {
  background-color: var(--v-primary-base);
}
.time {
  font-size: 80%;
  display: block;
  white-space: pre;
  text-align: right;
  color: #4A4A4A;
  margin-top: -0.2em;
  margin-bottom: -0.4em;
}
.message.self .time {
  color: #ccc;
}
</style>


